export default "__VITE_ASSET__BQCO8ZTj__"